import React from 'react'
import useBreakpoint from 'hooks/useBreakPoint'
import classNames from 'classnames'
import SlotGridSkeleton from '../SlotGridSkeleton'
import Practice from '../PracticeSkeleton'
import Detail from '../DetailSkeleton'
import '../index.scss'

const ListCardSkeleton: React.FC = () => {
  const { isSmallSize, isMediumSize, isLargeSize } = useBreakpoint()
  const cardStyles = classNames({
    '~p-3': isSmallSize,
    '~flex ~justify-between': !isSmallSize,
  })

  return (
    <div className="~box-border ~rounded ~p-10 ~m-5 ~bg-white ~max-h-[328.1px]">
      <div className={cardStyles}>
        {isSmallSize ? (
          <MobileListCardProviderSectionSkeleton />
        ) : (
          <>
            <ListCardProviderSectionSkeleton isMediumSize={isMediumSize} />
            {isMediumSize || isLargeSize ? (
              <div>
                <div className="animate ~h-10 ~rounded-3xs ~mb-2" />
                <div className="animate ~mt-3 ~h-4 ~w-percent-45 ~rounded-3xs" />
              </div>
            ) : (
              <div className="~basis-[43%] ~flex ~flex-col ~items-center">
                <SlotGridSkeleton />
                <div className="animate ~mt-2.5 ~h-4 ~w-percent-45 ~rounded-3xs" />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export const ListCardProviderSectionSkeleton: React.FC<{
  isMediumSize?: boolean
}> = ({ isMediumSize = false }) => {
  return (
    <div className="~flex ~mb-3 ~flex-auto">
      <div
        className={`animate ${
          isMediumSize ? '~size-[112px]' : '~size-[96px]'
        } ~rounded-percent-half ~mr-4`}
      />
      <div className="~flex-[1] ~w-skeleton-info">
        <div className="animate ~h-5 ~w-percent-85 ~rounded-3xs ~mb-2" />
        <div className="animate ~h-[14px] ~w-percent-60 ~rounded-2xs ~mb-8" />
        <Practice />
        <Practice />
        <div className="~mt-3 ~flex ~gap-2">
          <Detail />
          <Detail />
          <Detail />
        </div>
        {isMediumSize && (
          <>
            <div className="animate ~ml-[30px] ~w-skeleton-button ~h-12 ~rounded-3xs8 ~mb-3 ~mt-7" />
            <div className="animate ~ml-[110px] ~h-5 ~w-[185px] ~rounded-3xs" />
          </>
        )}
      </div>
    </div>
  )
}

export const MobileListCardProviderSectionSkeleton: React.FC = () => {
  return (
    <div className="~flex ~flex-col ">
      <div className="~flex ~justify-between ~w-full ~mb-5">
        <div className="animate ~size-16 ~rounded-percent-half ~mr-4" />
        <div className="~flex-auto ~pt-2.5">
          <div className="animate ~h-6 ~w-full ~rounded-3xs ~mb-2" />
          <div className="animate ~h-4 ~w-percent-60 ~rounded-2xs" />
        </div>
      </div>
      <div>
        <Practice />
        <Practice />
        <div className="animate ~h-12 ~rounded-[48px] ~mb-3" />
        <div className="animate ~m-auto ~h-5 ~w-percent-60 ~rounded-3xs" />
      </div>
    </div>
  )
}

export default ListCardSkeleton
